export default __webpack_public_path__ + "static/media/Hair_5_M_C1.712fad17.svg";